// src/components/pdf/generatePDF.js
import { pdf } from '@react-pdf/renderer';
import TennisReportPDF from './TennisReportPDF';
import { calculateAllStats } from '../../utils/statsCalculator';
import { calculateAllAdvancedStats } from '../../utils/advancedStatsCalculator';

/**
 * Génère et télécharge le PDF
 */
export const generatePlayerPDF = async ({ match, playerName, playerCode, comments }) => {
  try {
    console.log('📄 Génération du PDF avec react-pdf...');
    
    // Extraire les points
    const allPoints = match.engineState?.points || [];
    console.log(`📊 ${allPoints.length} points à analyser`);
    
    // Calculer les stats générales des deux joueurs
    const statsJ1 = calculateAllStats(allPoints, 'J1');
    const statsJ2 = calculateAllStats(allPoints, 'J2');
    
    console.log('📊 Stats générales calculées');
    
    // Calculer les stats avancées (tous points, pas de filtrage par set)
    const advancedStats = calculateAllAdvancedStats(allPoints, allPoints);
    
    console.log('📊 Stats avancées calculées');
    
    // Créer le document PDF
    const blob = await pdf(
      <TennisReportPDF
        match={match}
        playerName={playerName}
        playerCode={playerCode}
        statsJ1={statsJ1}
        statsJ2={statsJ2}
        advancedStats={advancedStats}
        comments={comments}
      />
    ).toBlob();
    
    console.log('✅ PDF généré, taille:', (blob.size / 1024 / 1024).toFixed(2), 'MB');
    
    // Télécharger
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `TenStats_${playerName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
    
    console.log('✅ PDF téléchargé');
    
  } catch (error) {
    console.error('❌ Erreur génération PDF:', error);
    throw error;
  }
};

export default generatePlayerPDF;